import { createRouter, createWebHistory, createMemoryHistory, createWebHashHistory } from 'vue-router';
import { recordPageLoadDuration } from '../utils/otel-config';
import { nextTick } from 'vue'; // 引入Vue的nextTick
import methods from "../utils/methods.js";
const iterator = methods.multidimensionalObjectArray();
import { useStore } from '@/store';
const store = useStore();
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';

export const routes = [
	{
		path: '/',
		redirect: '/home',
	},
	{
		path: '/signIn',
		name: 'signIn',
		meta: {
			title: '登录',
			titleKey: 'route.signIn',
		},
		component: () => import('@/views/account/signIn'),
		// redirect: '/home/online',
	},
	{
		path: '/changePassword',
		name: 'changePassword',
		meta: {
			title: '修改密码',
			titleKey: 'route.changePassword',
		},
		component: () => import('@/views/account/changePassword'),
	},
	{
		path: '/home',
		name: 'home',
		meta: {
			title: '首页',
			titleKey: 'route.home',
		},
		component: () => import('@/views/home/index'),
	},
	{
		path: '/search',
		name: 'search',
		meta: {
			title: '搜索',
			titleKey: 'route.search',
		},
		component: () => import('@/views/search/index'),
	},
	{
		path: '/schedule',
		name: 'schedule',
		meta: {
			title: '赛程',
			titleKey: 'route.schedule',
		},
		component: () => import('@/views/schedule/index'),
	},
	{
		path: '/liveRoomDetails',
		name: 'liveRoomDetails',
		meta: {
			title: '直播间',
			titleKey: 'route.liveRoomDetails',
		},
		component: () => import('@/views/schedule/liveRoomDetails'),
	},
	{
		path: '/MyliveRoomChat',
		name: 'MyliveRoomChat',
		meta: {
			title: '我的直播间聊天室',
		},
		component: () => import('@/views/schedule/myLiveRoomChat'),
	},
	{
		path: '/matchInfo',
		name: 'matchInfo',
		meta: {
			title: '比赛详情',
			titleKey: 'route.matchInfo',
		},
		component: () => import('@/views/schedule/matchInfo'),
	},
	{
		path: '/live',
		name: 'live',
		meta: {
			title: '直播',
			titleKey: 'route.live',
		},
		component: () => import('@/views/live/index2'),
	},
	{
		path: '/anchor',
		name: 'anchor',
		meta: {
			title: '主播',
			titleKey: 'route.anchor',
		},
		component: () => import('@/views/anchor/index'),
	},
	{
		path: '/information',
		name: 'information',
		meta: {
			title: '资讯',
			titleKey: 'route.information',
		},
		component: () => import('@/views/information/index'),
	},
	{
		path: '/message',
		name: 'message',
		meta: {
			title: '消息',
			titleKey: 'route.message',
		},
		component: () => import('@/views/message/index'),
		redirect: to => ({
			path: '/message/msg',
			query: to.query,
		}),
		children: [
			{
				path: 'msg',
				name: 'msg',
				meta: {
					title: '消息',
					titleKey: 'route.msg',
				},
				component: () => import('@/views/message/msg'),
			},
			{
				path: 'contacts',
				name: 'contacts',
				meta: {
					title: '联系人',
					titleKey: 'route.contacts',
				},
				component: () => import('@/views/message/contacts'),
			}
		]
	},
	{
		path: '/informationDetail',
		name: 'informationDetail',
		meta: {
			title: '资讯详情',
			titleKey: 'route.informationDetail',
		},
		component: () => import('@/views/information/details'),
	},
	{
		path: '/other',
		name: 'other',
		component: () => import('@/views/other/index'),
		redirect: '/other/aboutUs',
		children: [
			{
				path: 'aboutUs',
				name: 'aboutUs',
				meta: {
					title: '关于我们',
					titleKey: 'route.aboutUs',
				},
				component: () => import('@/views/other/childView.vue'),
				redirect: '/other/aboutUs/index',
				children: [
					{
						path: 'index',
						name: 'aboutUsIndex',
						meta: {
							title: '关于我们',
							titleKey: 'route.aboutUs',
						},
						component: () => import('@/views/other/aboutUs.vue'),
					}
				]
			},
			{
				path: 'user-related',
				name: 'userRelated',
				meta: {
					title: '用户相关',
					titleKey: 'route.userRelated',
				},
				component: () => import('@/views/other/childView.vue'),
				redirect: '/other/user-related/accountIssue',
				children: [
					{
						path: 'accountIssue',
						name: 'accountIssue',
						meta: {
							title: '账号问题',
							titleKey: 'route.accountIssue',
						},
						component: () => import('@/views/other/accountQuestion.vue'),
					},
					{
						path: 'viewQuestions',
						name: 'viewQuestions',
						meta: {
							title: '观看问题',
							titleKey: 'route.viewQuestions',
						},
						component: () => import('@/views/other/viewQuestions.vue'),
					},
					{
						path: 'userAgreement',
						name: 'userAgreement',
						meta: {
							title: '用户协议',
							titleKey: 'route.userAgreement',
						},
						component: () => import('@/views/other/components/userAgreement.vue'),
					},
					{
						path: 'privacyPolicy',
						name: 'privacyPolicy',
						meta: {
							title: '隐私政策',
							titleKey: 'route.privacyPolicy',
						},
						component: () => import('@/views/other/components/privacyPolicy.vue'),
					}
				]
			},
			{
				path: 'anchor-related',
				name: 'anchorRelated',
				meta: {
					title: '主播相关',
					titleKey: 'route.anchorRelated',
				},
				component: () => import('@/views/other/childView.vue'),
				redirect: '/other/anchor-related/broadcastTutorial',
				children: [
					{
						path: 'broadcastTutorial',
						name: 'broadcastTutorial',
						meta: {
							title: '开播教程 ',
							titleKey: 'route.broadcastTutorial',
						},
						component: () => import('@/views/other/broadcastTutorial.vue'),
					},
					{
						path: 'computerLiveStream',
						name: 'computerLiveStream',
						meta: {
							title: '电脑直播',
							titleKey: 'route.computerLiveStream',
						},
						component: () => import('@/views/other/computerLiveStream.vue'),
					},
					{
						path: 'anchorIssue',
						name: 'anchorIssue',
						meta: {
							title: '主播问题',
							titleKey: 'route.anchorIssue',
						},
						component: () => import('@/views/other/anchorIssue.vue'),
					},
					{
						path: 'liveStreamProtocol',
						name: 'liveStreamProtocol',
						meta: {
							title: '直播协议 ',
							titleKey: 'route.liveStreamProtocol',
						},
						component: () => import('@/views/other/components/liveProtocol.vue'),
					},
					{
						path: 'liveStreamStandards',
						name: 'liveStreamStandards',
						meta: {
							title: '直播规范  ',
							titleKey: 'route.liveStreamStandards',
						},
						component: () => import('@/views/other/components/liveSpecifications.vue'),
					}
				]
			},
			{
				path: 'contactAndCooperation',
				name: 'contactAndCooperation',
				meta: {
					title: '联系及合作',
					titleKey: 'route.contactAndCooperation',
				},
				component: () => import('@/views/other/childView.vue'),
				redirect: '/other/contactAndCooperation/index',
				children: [
					{
						path: 'index',
						name: 'contactAndCooperationIndex',
						meta: {
							title: '联系及合作',
							titleKey: 'route.contactAndCooperationIndex',
						},
						component: () => import('@/views/other/contact.vue'),
					}
				]
			},
		]
	},

	{
		path: '/platformSpe',
		name: 'platformSpe',
		meta: {
			title: '平台规范',
			titleKey: 'route.platformSpe',
		},
		component: () => import('@/views/other/platformSpe'),
	},
	{
		path: '/startBroadcasting',
		name: 'startBroadcasting',
		meta: {
			title: '我要开播',
			titleKey: 'route.startBroadcasting',
		},
		component: () => import('@/views/other/startBroadcasting'),
	},
	{
		path: '/help',
		name: 'help',
		meta: {
			title: '帮助中心',
			titleKey: 'route.help',
		},
		component: () => import('@/views/other/help'),
	},
	{
		path: '/anchorTools',
		name: 'anchorTools',
		meta: {
			title: '主播工具',
			titleKey: 'route.anchorTools',
		},
		component: () => import('@/views/other/anchorTools'),
	},
	{
		path: '/member',
		name: 'member',
		meta: {
			title: '用户中心',
			titleKey: 'route.member',
		},
		component: () => import('@/views/member/root.vue'),
		redirect: '/member/profile',
		children: [
			{
				path: 'profile', // 完整路径为 /member/setting/profile
				name: 'memberSettingProfile',
				meta: {
					title: '个人资料',
					titleKey: 'route.memberSettingProfile',
					icon: require('@/assets/images/member-profile.png'),
					icon2: require('@/assets/images/member-profile-active.png'),
				},
				component: () => import('@/views/member/setting-profile.vue'),
			},
			{
				path: 'index', // 完整路径为 /member/anchor/index
				name: 'memberAnchorIndex',
				meta: {
					title: '主播概要',
					titleKey: 'route.memberAnchorIndex',
					icon: require('@/assets/images/member-anchorIndex.png'),
					icon2: require('@/assets/images/member-anchorIndex-active.png'),
				},
				component: () => import('@/views/member/anchor-index.vue'),
			},
			{
				path: 'timetable', // 完整路径为 /member/anchor/timetable
				name: 'memberAnchorTimetable',
				meta: {
					title: '直播时间表',
					titleKey: 'route.memberAnchorTimetable',
					icon: require('@/assets/images/member-anchorTimetable.png'),
					icon2: require('@/assets/images/member-anchorTimetable-active.png'),
				},
				component: () => import('@/views/member/anchor-timetable.vue'),
			},
			{
				path: 'records', // 完整路径为 /member/anchor/records
				name: 'memberAnchorRecords',
				meta: {
					title: '直播记录',
					titleKey: 'route.memberAnchorRecords',
					icon: require('@/assets/images/member-anchorRecords.png'),
					icon2: require('@/assets/images/member-anchorRecords-active.png'),
				},
				component: () => import('@/views/member/anchor-records.vue'),
			},
			{
				path: 'room-admin', // 完整路径为 /member/anchor/room-admin
				name: 'memberAnchorRoomAdmin',
				meta: {
					title: '房管',
					titleKey: 'route.memberAnchorRoomAdmin',
					icon: require('@/assets/images/member-anchorRoomAdmin.png'),
					icon2: require('@/assets/images/member-anchorRoomAdmin-active.png'),
				},
				component: () => import('@/views/member/anchor-room-admin.vue'),
			},
			{
				path: 'quick-chat-set',
				name: 'memberQuickChatSet',
				meta: {
					title: '快捷聊天设置',
					titleKey: 'route.memberQuickChatSet',
					icon: require('@/assets/images/member-quickChatSet.png'),
					icon2: require('@/assets/images/member-quickChatSet-active.png'),
				},
				component: () => import('@/views/member/quick-chat-set.vue'),
			},
			{
				path: 'following',
				name: 'memberIndexFollowing',
				meta: {
					title: '我的关注',
					titleKey: 'route.memberIndexFollowing',
					icon: require('@/assets/images/member-following.png'),
					icon2: require('@/assets/images/member-following-active.png'),
				},
				component: () => import('@/views/member/index-following.vue'),
			},
			{
				path: 'fans', // 完整路径为 /member/index/fans
				name: 'memberIndexFans',
				meta: {
					title: '我的粉丝',
					titleKey: 'route.memberIndexFans',
					icon: require('@/assets/images/member-fans.png'),
					icon2: require('@/assets/images/member-fans-active.png'),
				},
				component: () => import('@/views/member/index-fans.vue'),
			},
			{
				path: 'blocklist', // 完整路径为 /member/index/blocklist
				name: 'memberIndexBlocklist',
				meta: {
					title: '黑名单',
					titleKey: 'route.memberIndexBlocklist',
					icon: require('@/assets/images/member-blocklist.png'),
					icon2: require('@/assets/images/member-blocklist-active.png'),
				},
				component: () => import('@/views/member/index-blocklist.vue'),
			},

			{
				path: 'signalsource', // 完整路径为 /member/anchor/timetable
				name: 'memberSignalSource',
				meta: {
					title: '信号源',
					titleKey: 'route.memberSignalSource',
					icon: require('@/assets/images/member-source.png'),
					icon2: require('@/assets/images/member-source-active.png'),
				},
				component: () => import('@/views/member/signal-source.vue'),
			},
			{
				path: 'setting', // 完整路径为 /member/setting/setting
				name: 'memberSettingSetting',
				meta: {
					title: '我的设置',
					titleKey: 'route.memberSettingSetting',
					icon: require('@/assets/images/member-setting.png'),
					icon2: require('@/assets/images/member-setting-active.png'),
				},
				component: () => import('@/views/member/setting-setting.vue'),
			},
			{
				path: 'index', // 完整路径为 /member/setting/profile
				name: 'memberContactIndex',
				meta: {
					title: '客服及合作',
					titleKey: 'route.memberContactIndex',
					icon: require('@/assets/images/member-contactIndex.png'),
					icon2: require('@/assets/images/member-contactIndex-active.png'),
				},
				component: () => import('@/views/member/contact.vue'),
			},
		]
	},
	{
		path: '/member2',
		name: 'member2',
		meta: {
			title: '用户中心',
			titleKey: 'route.member2',
		},
		component: () => import('@/views/member2/root.vue'),
		redirect: '/member2/personal',
		children: [
			{
				path: 'personal',
				name: 'memberPersonal',
				meta: {
					title: '个人中心',
					titleKey: 'route.memberPersonal',
				},
				redirect: '/member2/personal/profile',
				component: () => import('@/views/member2/personal'),
				children: [
					{
						path: 'profile',
						name: 'memberProfile',
						meta: {
							title: '个人资料',
							titleKey: 'route.memberProfile',
							icon: require('@/assets/images/member-personalProfile.png'),
							icon2: require('@/assets/images/member-personalProfile-active.png'),
						},
						redirect: '/member2/personal/profile/basicInfo',
						component: () => import('@/views/member2/personal/profile'),
						children: [
							{
								path: 'basicInfo',
								name: 'memberBasicInfo',
								meta: {
									title: '基本资料',
									titleKey: 'route.memberBasicInfo',
								},
								component: () => import('@/views/member2/personal/profile/basicInfo.vue'),
							},
							{
								path: 'editNick',
								name: 'memberEditNick',
								meta: {
									title: '修改昵称',
									titleKey: 'route.memberEditNick',
								},
								component: () => import('@/views/member2/personal/profile/editNick.vue'),
							},
							{
								path: 'editPhone',
								name: 'memberEditPhone',
								meta: {
									title: '修改手机',
									titleKey: 'route.memberEditPhone',
								},
								component: () => import('@/views/member2/personal/profile/editPhone.vue'),
							},
							{
								path: 'editPassword',
								name: 'memberEditPassword',
								meta: {
									title: '修改密码',
									titleKey: 'route.memberEditPassword',
								},
								component: () => import('@/views/member2/personal/profile/editPassword.vue'),
							},
						]
					},
					{
						path: 'mission',
						name: 'memberMission',
						meta: {
							title: '任务中心',
							titleKey: 'route.memberMission',
							icon: require('@/assets/images/member-mission.png'),
							icon2: require('@/assets/images/member-mission-active.png'),
						},
						component: () => import('@/views/member2/personal/mission'),
					},
					{
						path: 'property',
						name: 'memberProperty',
						meta: {
							title: '我的财产',
							titleKey: 'route.memberProperty',
							icon: require('@/assets/images/member-property.png'),
							icon2: require('@/assets/images/member-property-active.png'),
						},
						component: () => import('@/views/member2/personal/property'),
					},
					{
						path: 'follow',
						name: 'memberPersonalFollow',
						meta: {
							title: '我的关注',
							titleKey: 'route.memberPersonalFollow',
							icon: require('@/assets/images/member-follow.png'),
							icon2: require('@/assets/images/member-follow-active.png'),
						},
						component: () => import('@/views/member/index-following.vue'),
					},
					{
						path: 'fans',
						name: 'memberPersonalFans',
						meta: {
							title: '我的粉丝',
							titleKey: 'route.memberPersonalFans',
							icon: require('@/assets/images/member-personalFans.png'),
							icon2: require('@/assets/images/member-personalFans-active.png'),
						},
						component: () => import('@/views/member/index-fans.vue'),
					},
					{
						path: 'blocklist',
						name: 'memberPersonalBlocklist',
						meta: {
							title: '黑名单',
							titleKey: 'route.memberPersonalBlocklist',
							icon: require('@/assets/images/member-personalBlocklist.png'),
							icon2: require('@/assets/images/member-personalBlocklist-active.png'),
						},
						component: () => import('@/views/member/index-blocklist.vue'),
					},
					{
						path: 'spending',
						name: 'memberSpending',
						meta: {
							title: '积分流水',
							titleKey: 'route.memberSpending',
							icon: require('@/assets/images/member-spending.png'),
							icon2: require('@/assets/images/member-spending-active.png'),
						},
						component: () => import('@/views/member2/personal/spending'),
					},
					{
						path: 'setting', // 完整路径为 /member/setting/setting
						name: 'memberSetting',
						meta: {
							title: '我的设置',
							titleKey: 'route.memberSetting',
							icon: require('@/assets/images/member-liveseting.png'),
							icon2: require('@/assets/images/member-liveseting-active.png'),
						},
						component: () => import('@/views/member/setting-setting.vue'),
					},
					{
						path: 'contact', // 完整路径为 /member/setting/profile
						name: 'memberContact',
						meta: {
							title: '客服及合作',
							titleKey: 'route.memberContact',
							icon: require('@/assets/images/member-personalContact.png'),
							icon2: require('@/assets/images/member-personalContact-active.png'),
						},
						component: () => import('@/views/member/contact.vue'),
					},
				],
			},
			{
				path: 'anchor',
				name: 'memberAnchor',
				meta: {
					title: '我是主播',
					titleKey: 'route.memberAnchor',
				},
				redirect: '/member2/anchor/anchor-dedicated',
				component: () => import('@/views/member2/anchor'),
				children: [
					// {
					// 	path: 'liveseting',
					// 	name: 'memberAnchorLiveseting',
					// 	meta: {
					// 		title: '直播设置',
					// 		icon:require('@/assets/images/member-liveseting.png'),
					// 		icon2:require('@/assets/images/member-liveseting-active.png'),
					// 	},
					// 	component: () => import('@/views/member2/anchor/liveseting'),
					// },
					{
						path: 'anchor-dedicated',
						name: 'memberAnchorDedicated',
						meta: {
							title: '主播专用',
							titleKey: 'route.memberAnchorDedicated',
							icon: require('@/assets/images/member-anchorDedicated.png'),
							icon2: require('@/assets/images/member-anchorDedicated-active.png'),
						},
						redirect: '/member2/anchor/anchor-dedicated/timetable',
						component: () => import('@/views/member2/anchor/anchor-dedicated'),
						children: [
							// {
							// 	path: 'summary',
							// 	name: 'memberAnchorSummary',
							// 	meta: {
							// 		title: '主播概要',
							// 		icon:require('@/assets/images/member-anchorIndex.png'),
							// 		icon2:require('@/assets/images/member-anchorIndex-active.png'),
							// 	},
							// 	component: () => import('@/views/member2/anchor/summary'),
							// 	// component: () => import('@/views/member/anchor-index.vue'),
							// },
							{
								path: 'timetable',
								name: 'memberAnchorDedicatedTimetable',
								meta: {
									title: '直播时间表',
									titleKey: 'route.memberAnchorDedicatedTimetable',
									// icon:require('@/assets/images/member-anchorTimetable.png'),
									// icon2:require('@/assets/images/member-anchorTimetable-active.png'),
								},
								component: () => import('@/views/member/anchor-timetable.vue'),
							},
							{
								path: 'records',
								name: 'memberAnchorDedicatedRecords',
								meta: {
									title: '直播记录',
									titleKey: 'route.memberAnchorDedicatedRecords',
									// icon:require('@/assets/images/member-anchorRecords.png'),
									// icon2:require('@/assets/images/member-anchorRecords-active.png'),
								},
								component: () => import('@/views/member/anchor-records.vue'),
							},
							{
								path: 'signalsource',
								name: 'memberAnchorSignalSource',
								meta: {
									title: '信号源',
									titleKey: 'route.memberAnchorSignalSource',
									icon: require('@/assets/images/member-source.png'),
									icon2: require('@/assets/images/member-source-active.png'),
								},
								component: () => import('@/views/member/signal-source.vue'),
							},
						]
					},
					{
						path: 'room-setup',
						name: 'memberAnchorRoomSetup',
						meta: {
							title: '房间设置',
							titleKey: 'route.memberAnchorRoomSetup',
							icon: require('@/assets/images/member-roomSetup.png'),
							icon2: require('@/assets/images/member-roomSetup-active.png'),
						},
						redirect: '/member2/anchor/room-setup/room-admin',
						component: () => import('@/views/member2/anchor/room-setup'),
						children: [
							{
								path: 'room-admin',
								name: 'memberRoomSetupRoomAdmin',
								meta: {
									title: '房管',
									titleKey: 'route.memberRoomSetupRoomAdmin',
									icon: require('@/assets/images/member-anchorRoomAdmin.png'),
									icon2: require('@/assets/images/member-anchorRoomAdmin-active.png'),
								},
								component: () => import('@/views/member/anchor-room-admin.vue'),
							},
							{
								path: 'quick-chat-set',
								name: 'memberAnchorQuickChatSet',
								meta: {
									title: '快捷聊天设置',
									titleKey: 'route.memberAnchorQuickChatSet',
									icon: require('@/assets/images/member-quickChatSet.png'),
									icon2: require('@/assets/images/member-quickChatSet-active.png'),
								},
								component: () => import('@/views/member/quick-chat-set.vue'),
							},
						]
					},
				],
			},
			{
				path: 'expert',
				name: 'memberExpert',
				meta: {
					title: '我是专家',
					titleKey: 'route.memberExpert',
				},
				redirect: '',
				component: () => import('@/views/member2/expert'),
				children: [],
			}
		],
	},
	{
		path: '/404',
		name: '404',
		component: () => import('@/components/404'),
	},
]
const router = createRouter({
	history: createWebHistory(), //createWebHashHistory(), //createMemoryHistory
	routes,
	// 刷新时，滚动条位置还原
	scrollBehavior: () => ({ left: 0, top: 0 })
})
const whiteList = [
	'/signIn',
	'/404',
] // no redirect whitelist
const loginList = [
	'/message'
]
let routeObjectArray = new iterator(routes, { key: 'path' });
let isMessageRoute = (route) => /^\/message(\/|$)/.test(route.path);
router.beforeEach(async (to, from) => {
	to._startTime = performance.now();
	methods.tryIt(() => {
		let body = document.querySelector('body');
		if (/hidden/.test(body.style.overflow)) {
			body.style.overflow = 'unset'; //如果body被某些插件设置了overflow:hidden,在路由切换时需要将其解开；
		}
	})
	NProgress.start();
	// if(to.meta&&to.meta.title){
	// 	document.title = to.meta.title;
	// }
	// console.log(to,from);
	// console.log('router.localStorage',router.localStorage)
	const hasToken = router.localStorage.getItem('token');

	if (hasToken) {

		let checkRouter = checkRouterIsHas(to); //检查路由是否存在
		// new RegExp('/participatingTeams').test(to.path)
		if (!checkRouter) return { path: '/404', query: { from: to.path } };
		// const hasUserInfo = store.state.user.userName;
		// if (!hasUserInfo) {
		// 	console.log('没有用户信息')
		// 	// get user info
		// 	let pathObj = { path: `/signIn?redirect=${to.path}` };
		// 	await store.action.user.getInfo().then(()=>{
		// 		pathObj = null;
		// 	}).catch(err=>{
		// 		if(/ERR_NETWORK/.test(err.code)){
		// 			pathObj = false;//取消导航
		// 		}
		// 		if(err.errType==1){
		// 			router.localStorage.removeItem('token');
		// 		}
		// 	});
		// 	if(pathObj!=null){
		// 		return pathObj;
		// 	}
		// }
	} else {
		let checkRouter = checkRouterIsHas(to); //检查路由是否存在
		if (!checkRouter) return { path: '/404' };
		let has = loginList.find(e => new RegExp(e).test(to.path));//需要登录的页面
		if (has) {
			router.$bus.emit('showLoginPopup');//打开登录弹窗
			if (isMessageRoute(to)) {
				return true;
			}
			return false;//取消导航
			// return { 
			// 	path: `/signIn`,
			// 	query:{
			// 		redirect:to.path
			// 	},
			// };
		}
	}
	// if(to.path == '/test')return false;//return false;取消导航
})
var checkRouterIsHas = (to) => {
	let hasRoute = routeObjectArray.find((e, i, level, parent) => {
		let path = '';
		//存在parent时需要将父级的path拼接上，进行完整比较，如：/competition/outline
		if (parent) {
			let parentPathArr = [];
			let parentPathObjArr = new iterator(parent, { childrenKey: '_parent', key: 'path' });
			parentPathObjArr.forEach((p, i) => {
				if (p.path) {
					parentPathArr.push(p.path);
				} else {
					if (i == 'path') parentPathArr.push(p);
				}
			})
			// 此时获得了父级路由的path
			let parentPath = parentPathArr.reverse() //倒置数组
				.map(e => !/^\//.test(e) ? '/' + e : e) //补上斜杠"/"
				.join('');//拼接为字符串
			path = parentPath + '/' + e.path;
		} else {
			path = e.path;
		}
		return path == to.path;
	})
	console.log('是否存在路由：', hasRoute);
	return hasRoute;
}
router.afterEach(async (to, from) => {
	NProgress.done();
	if (!to._startTime) return; // 兜底：避免异常场景
	await nextTick(); // 等DOM渲染完成
	const renderDuration = performance.now() - to._startTime;
	// 上报指标
	const fullUrl = `${window.location.origin}${to.fullPath}`;
	console.log('Full URL:', fullUrl);
	recordPageLoadDuration(renderDuration, window.__my_res_ver, fullUrl, 'route');
	// 可选：用完清空，避免路由对象冗余
	delete to._startTime;

})
export default router;